import { URLInput } from '../../../../URLInput'
import { FieldInputProps, UrlField } from '../../types'

export const FieldURL = <T extends UrlField>({
  field,
  onChange,
  readOnly,
  setIsEditing,
}: FieldInputProps<T>) => {
  return (
    <URLInput
      readOnly={readOnly}
      htmlId={`field-${field.id}`}
      initialUrl={field.data?.value?.url}
      initialLabel={field.data?.value?.label}
      onOpenChange={setIsEditing}
      onSubmit={(value) =>
        onChange({
          fieldId: field.id,
          data: { id: field.data?.id || null, value },
        })
      }
      placeholderText="None"
    />
  )
}
